// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2cMkG","header":"ReportDetails_header__po7c5","title":"ReportDetails_title__3hq39","left":"ReportDetails_left__3M2AS"};